module.exports = __webpack_public_path__ + "static/media/LateralViewXray.50db42a7.png";